import { useFeature } from "@growthbook/growthbook-react";

import { gb } from "./growthBook";

export interface RiseCrmFeatureFlags {
	ValidateEmailDomainForAdminUsers?: boolean;
	"MMS-196-Jaris-POC"?: boolean;
}

export const isFeatureEnabled = (key: keyof RiseCrmFeatureFlags) => {
	return gb.isOn(key);
};

export const useIsFeatureEnabled = (key: keyof RiseCrmFeatureFlags): boolean => {
	return useFeature(key).on;
};
